export default "__VITE_ASSET__b8de40f7__"